import { useEffect } from 'react';
import { Skeleton } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import ValuationList from './ValuationList';
import ValuationForm from './ValuationForm';

import { effects, selectors } from '../slice';

interface ValuationContentProps {
  isHumbergerValuation: boolean;
  handleSwitchHumbergerValuation: () => void;
  isUpdateMode: boolean;
  setUpdateMode: (data: boolean) => void;
  isShowResultSection: boolean;
  setShowResultSection: any;
}

const ValuationContent = ({
  isHumbergerValuation,
  handleSwitchHumbergerValuation,
  isUpdateMode,
  setUpdateMode,
  isShowResultSection,
  setShowResultSection,
}: ValuationContentProps) => {
  const dispatch = useDispatch();
  const state = useSelector(selectors);
  const { getValuationTemplate, getValuationTemplateLoad } = state;
  const { isLoading: isLoadingValuationDetail } = getValuationTemplateLoad;

  const { data: dataValuationTemplate } = getValuationTemplate;

  // didmount
  useEffect(() => {
    // HIT API getValuationTemplate
    dispatch(effects.getValuationTemplate());

    // HIT API getValuationMetrics
    dispatch(effects.getValuationMetrics());
  }, [dispatch]);

  const handleOnClickListValuation = (valuationId) => {
    dispatch(effects.getValuationTemplateLoad(valuationId));

    // hide humberger
    handleSwitchHumbergerValuation();

    // change state update mode to true
    setUpdateMode(true);
  };

  // render ValuationList
  if (isHumbergerValuation) {
    return (
      <ValuationList
        handleSwitchHamberger={handleSwitchHumbergerValuation}
        dataTemplate={dataValuationTemplate}
        onClick={handleOnClickListValuation}
        setUpdateMode={setUpdateMode}
        setShowResultSection={setShowResultSection}
      />
    );
  }

  if (isLoadingValuationDetail && isUpdateMode) {
    return <Skeleton active paragraph={{ rows: 6 }} />;
  }

  return (
    <ValuationForm
      isUpdateMode={isUpdateMode}
      setUpdateMode={setUpdateMode}
      isShowResultSection={isShowResultSection}
      setShowResultSection={setShowResultSection}
    />
  );
};

export default ValuationContent;
